module.exports = __webpack_public_path__ + "img/map_icon_blue.97c6dae7.svg";